export const getAddresses = (state) => {
    return state.api.entities.addresses
}